// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__MQuND","info":"Note_info__3OZky","note":"Note_note__2rb64","actions":"Note_actions__1I_rY"};